import { eksmoBP } from 'Lib/bp/bp';
import { getW } from 'Lib/w/w';

const cRowSpoilerActive = 'table-list__row_spoiler-active';
const sSpoiler = '.table-list__spoiler';
const sRow = '.table-list__row';
const sCellName = '.table-list__name';
const sSpoilerCont = '.table-list__description';
const verticalOffsetOnCellD = 23;

function setSpoilerD() {
    $(sSpoiler).each(function () {
        const $this = $(this);
        const $row = $this.closest(sRow);

        $this.height(0);

        if ($row.length) {
            const $cellName = $row.find(sCellName).first();

            $row.removeClass(cRowSpoilerActive);

            if ($cellName.length) {
                const $removeSpoiler = $this.remove();
                let hCellName = $cellName.innerHeight();
                const dataDefH = $cellName.attr('data-def-h');
                let numCellWidth = 0;
                let arrowCellWidth = 0;
                let additionOffset = 0;
                const curCellNum = $row.find('.table-list__num').first();
                const curCellHelper = $row.find('.table-list__cell_helper').first();

                if (typeof dataDefH === 'string') {
                    hCellName = parseInt(dataDefH);
                }

                if (curCellNum.length) {
                    numCellWidth = curCellNum.outerWidth(true);
                    additionOffset += 5;
                }

                if (curCellHelper.length) {
                    arrowCellWidth = curCellHelper.outerWidth(true);
                    additionOffset += 5;
                }

                $removeSpoiler.css({ 'width': $row.width() - numCellWidth - arrowCellWidth - additionOffset, 'bottom': 'auto', 'top': hCellName - verticalOffsetOnCellD });
                $cellName.attr('data-def-h', hCellName).height(hCellName - (verticalOffsetOnCellD * 2)).append($removeSpoiler);
            }
        }
    });
}

function setHeightCellNameD($r, isShow) {
    if ($r.length) {
        const $cellName = $r.find(sCellName).first();
        const $cont = $r.find(sSpoilerCont).first();

        if ($cellName.length && $cont.length) {
            let dataDefHCellName = $cellName.attr('data-def-h');

            if (typeof dataDefHCellName === 'string') {
                dataDefHCellName = parseInt(dataDefHCellName);

                if (isShow) {
                    $cellName.css({ 'height': dataDefHCellName + $cont.outerHeight(true) });
                } else {
                    $cellName.css({ 'height': dataDefHCellName });
                }
            }
        }
    }
}

if (getW() > eksmoBP.xsMax) {
    setSpoilerD();
}

$('body').on('eksmoResizeWidth', () => {
    if (getW() > eksmoBP.xsMax) {
        setSpoilerD();
    }
});

$('.table-list__arrow').on('click', function () {
    const $row = $(this).closest(sRow);
    const $spoiler = $row.find(sSpoiler).first();

    if ($spoiler.length) {
        const $cont = $spoiler.find(sSpoilerCont).first();

        if ($cont.length && $row.length) {
            if (!$row.hasClass(cRowSpoilerActive)) {
                if (getW() > eksmoBP.xsMax) {
                    setHeightCellNameD($row, true);
                }

                $row.addClass(cRowSpoilerActive);
                $spoiler.height($cont.outerHeight(true));
            } else {
                $row.removeClass(cRowSpoilerActive);
                $spoiler.height(0);

                if (getW() > eksmoBP.xsMax) {
                    setHeightCellNameD($row, false);
                }
            }
        }
    }
});